module.exports = __webpack_public_path__ + "static/murdoch-video-poster-25e4c9ce36f4f6182855617b341d8326.png";